// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__3Nf8I","radioRow":"SimpleQuestionBuilderModal_radioRow__1VA-F"};